import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { useSelector } from "react-redux";
import { AxiosContext } from "../services/axios/AxiosContext";
import { ReduxState } from "../store/storeTypes";
import {
  Account,
  Company,
  ObjectIdOrString,
  User,
} from "@mysnowscape/snow-lib";

export interface CompanyAccountResponse {
  account: Pick<
    Account,
    "licensedCompanies" | "usage" | "allowances" | "stripe"
  >;
  company: Company;
  owner: User;
}
// TODO: remove once we upgrade to snowlib >= 3.2.0
export interface CompanyAccountResponseShim extends CompanyAccountResponse {
  account: CompanyAccountResponse["account"] & {
    usage: CompanyAccountResponse["account"]["usage"] & {
      siteMapsEditedThisMonth: ObjectIdOrString[];
    };
  };
}

export default function useAccountInfo() {
  const axios = useContext(AxiosContext);
  const currentCompanyId = useSelector(
    (s: ReduxState) => s.currentUser?.currentCompanyId,
  );

  const query = useQuery<CompanyAccountResponseShim>({
    queryKey: [`company/${currentCompanyId}/account`],
    queryFn: async () =>
      (await axios.get(`company/${currentCompanyId}/account`)).data,
    enabled: currentCompanyId != null,
  });

  return {
    isLoading: query.isLoading,
    data: query.data,
  };
}
